import { Router } from '@angular/router';

export interface VideoStreamData {
  id: string | number;
  streaming_platform?: string;
  stream_status?: string;
  asset_playback_id?: string;
}

export function storeVideoSession(data: VideoStreamData): void {
  if (globalThis.window?.sessionStorage) {
    sessionStorage.setItem('view_video', JSON.stringify(data));
  }
}

function resolveVideoRoute(
  data: VideoStreamData,
  basePath: 'live' | 'videos',
  requireAssetForScheduled: boolean,
): string[] {
  if (data.stream_status === 'L') {
    return [`${basePath}/1/${data.id}`];
  }
  if (data.stream_status === 'S') {
    if (!requireAssetForScheduled || data.asset_playback_id) {
      return [`${basePath}/0/${data.id}`];
    }
  }
  return [`${basePath}/-1/${data.id}`];
}

export function navigateToVideoStream(
  router: Router,
  data: VideoStreamData,
  options: {
    live: boolean;
    requireAssetForScheduled?: boolean;
  },
): void {
  storeVideoSession(data);

  if (data.streaming_platform === 'IVS') {
    router.navigate(resolveVideoRoute(data, 'live', false));
    return;
  }

  const basePath = options.live ? 'live' : 'videos';
  const requireAsset =
    options.requireAssetForScheduled ?? !options.live;
  router.navigate(resolveVideoRoute(data, basePath, requireAsset));
}
